import React from "react";
import Image from "next/image";
import Link from "next/link";

import { twMerge } from "tailwind-merge";
import { FaStar, FaStarHalf, FaRegStar } from "react-icons/fa";

const Frame = ({ cta, children, ...props }) => {
  return cta ? (
    <Link href={cta} target="_blank" {...props}>
      {children}
    </Link>
  ) : (
    <div {...props}>{children}</div>
  );
};

function CustomerReviewCard({
  className = "",
  name,
  title,
  content,
  image,
  stars,
  cta,
  reviewFromLogo,
  variant = "default", //  default, centralized
}) {
  return (
    <Frame
      cta={cta}
      className={twMerge(
        "flex-[0_0_auto] bg-white rounded-2xl p-4 flex flex-col justify-center items-center w-full border border-gray-500 hover:-translate-y-[2px] hover:-translate-x-[2px] hover:shadow-[3px_3px_0_1px_#000] transition-transform duration-300 ease-in-out",
        className,
        variant === "centralized" ? "text-center" : "text-center xl:text-left"
      )}
    >
      <div
        className={twMerge(
          "flex flex-col items-center gap-x-2",
          variant === "centralized" ? "" : "xl:flex-row"
        )}
      >
        <div
          className={`relative w-24 h-24 rounded-full p-2 grid place-items-center`}
        >
          {reviewFromLogo && (
            <Image
              className="absolute bottom-2 right-2 w-5 h-5 rounded-full bg-white p-0.5 object-cover"
              src={reviewFromLogo}
              alt={name}
              width={20}
              height={20}
            />
          )}

          <Image
            className="mx-auto w-full h-full rounded-full shadow-lg"
            src={image}
            alt={name}
            width={80}
            height={80}
          />
        </div>

        <div>
          <p className="text-xl font-medium">{name}</p>

          {stars && (
            <div className="flex gap-1 items-center justify-center text-base">
              {[1, 2, 3, 4, 5].map((star, index) => (
                <div key={index} className="">
                  {stars >= star ? (
                    <FaStar className="text-yellow-400" />
                  ) : stars >= star - 0.5 ? (
                    <FaStarHalf className="text-yellow-400" />
                  ) : (
                    <FaRegStar className="text-yellow-400" />
                  )}
                </div>
              ))}
              <div className="">
                <span className="text-gray-400">{stars}/ 5</span>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="mt-1 pb-2 xl:pb-0 grow">
        {title && <div>{`"${title}"`}</div>}

        <p className="w-full max-h-full text-gray-900 text-lg">{content}</p>
      </div>
    </Frame>
  );
}

export default CustomerReviewCard;
